import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Film, Tv2, Radio, Users, CreditCard, Tag, LogOut, Home, Mail, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const sections = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/movies", label: "Movies", icon: Film },
  { to: "/admin/series", label: "Series", icon: Tv2 },
  { to: "/admin/channels", label: "Live TV", icon: Radio },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/subscriptions", label: "Subscriptions", icon: CreditCard },
  { to: "/admin/email", label: "Email", icon: Mail },
  { to: "/admin/categories", label: "Categories", icon: Tag },
  { to: "/admin/settings", label: "Site Settings", icon: SettingsIcon },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] text-white flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#0a0a0a] border-r border-white/5 flex flex-col h-screen sticky top-0">
        <Link to="/admin" className="flex items-center gap-2 px-6 py-6 border-b border-white/5">
          <div className="w-9 h-9 rounded-lg bg-[#E50914] flex items-center justify-center font-black" style={{ fontFamily: "Outfit" }}>D</div>
          <div>
            <div className="font-black text-sm" style={{ fontFamily: "Outfit" }}>Djino<span className="text-[#E50914]">Admin</span></div>
            <div className="text-[10px] text-[#888] uppercase tracking-wider">Control Center</div>
          </div>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {sections.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              end={s.end}
              data-testid={`admin-nav-${s.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition ${
                  isActive ? "bg-[#E50914]/15 text-white border border-[#E50914]/30" : "text-[#aaa] hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <s.icon size={18} /> {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5">
          <Link to="/browse" className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-[#aaa] hover:bg-white/5 hover:text-white" data-testid="admin-back-app">
            <Home size={18} /> Back to App
          </Link>
          <button onClick={() => { logout(); navigate("/login"); }} className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-[#aaa] hover:bg-white/5 hover:text-white" data-testid="admin-logout">
            <LogOut size={18} /> Sign Out
          </button>
          <div className="mt-3 px-3 text-xs">
            <div className="text-white font-semibold">{user?.name}</div>
            <div className="text-[#888]">{user?.email}</div>
          </div>
        </div>
      </aside>
      <main className="flex-1 p-6 sm:p-10 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
